import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-88cf8ffc"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "result-label ms-1 mb-1"
  }, "Result:", -1);
});

var _hoisted_2 = {
  class: "user-preview mb-4"
};
var _hoisted_3 = {
  class: "username"
};
var _hoisted_4 = {
  class: "date"
};
var _hoisted_5 = {
  class: "actions"
};
import { ref, reactive, onMounted, computed } from "vue";
import { DateTime } from "luxon";
import { UseTimeAgo } from "@vueuse/components";
import { Search } from "@vicons/ionicons5";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { getErrorMessage, handleError } from "@/utils/errors";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  props: {
    loader: null,
    focus: {
      type: Boolean,
      default: false
    }
  },
  emits: ["search"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var LoaderState = LoaderStateEnum;
    var innerLoader = ref(LoaderStateEnum.Idle);
    var notFound = ref(false);
    var errors = reactive({});
    var model = reactive({
      query: ""
    });
    var rules = {
      query: [{
        required: true
      }]
    };
    var form = ref(null);
    var input = ref(null);
    var user = ref(null);
    onMounted(function () {
      if (props.focus === true && input.value) {
        input.value.focus();
      }
    });
    var loading = computed(function () {
      return props.loader === LoaderStateEnum.Loading || innerLoader.value === LoaderStateEnum.Loading;
    });

    var lookup = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$http$get, match;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (form.value) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return form.value.validate();

              case 5:
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", false);

              case 10:
                emit("search", model.query);
                innerLoader.value = LoaderStateEnum.Loading;
                _context2.prev = 12;
                _context2.next = 15;
                return http.get("users/lookup/".concat(model.query));

              case 15:
                _yield$http$get = _context2.sent;
                match = _yield$http$get.data;
                user.value = match;
                innerLoader.value = LoaderStateEnum.Idle;
                _context2.next = 27;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t1 = _context2["catch"](12);
                _context2.next = 25;
                return handleError(_context2.t1, {
                  http: function () {
                    var _http = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                      var _e$response, _e$response2, _e$response2$data;

                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              notFound.value = ((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404;
                              return _context.abrupt("return", notFound.value ? "No user found." : getErrorMessage((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.errors));

                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function http(_x) {
                      return _http.apply(this, arguments);
                    }

                    return http;
                  }()
                });

              case 25:
                errors.lookup = _context2.sent;
                innerLoader.value = LoaderStateEnum.Failed;

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 7], [12, 21]]);
      }));

      return function lookup() {
        return _ref2.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _component_n_input = _resolveComponent("n-input");

      var _component_n_icon = _resolveComponent("n-icon");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_input_group = _resolveComponent("n-input-group");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_form = _resolveComponent("n-form");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_text = _resolveComponent("n-text");

      var _component_n_divider = _resolveComponent("n-divider");

      var _component_n_collapse_transition = _resolveComponent("n-collapse-transition");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_n_form, {
        ref_key: "form",
        ref: form,
        model: _unref(model),
        rules: rules,
        class: "lookup-form"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_form_item, {
            path: "query"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_input_group, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_input, {
                    ref_key: "input",
                    ref: input,
                    placeholder: "Username or Email",
                    "input-props": {
                      type: 'search',
                      autocomplete: 'off'
                    },
                    disabled: _unref(loading),
                    loading: innerLoader.value === _unref(LoaderState).Loading,
                    value: _unref(model).query,
                    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(model).query = $event;
                    }),
                    onKeyup: _withKeys(lookup, ["enter"])
                  }, null, 8, ["disabled", "loading", "value", "onKeyup"]), _createVNode(_component_n_button, {
                    type: "primary",
                    disabled: _unref(loading),
                    onClick: lookup
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_n_icon, {
                        size: "20"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_unref(Search))];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["disabled"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["model"]), _createVNode(_component_n_collapse_transition, {
        show: innerLoader.value !== _unref(LoaderState).Loading
      }, {
        default: _withCtx(function () {
          return [innerLoader.value === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            class: "white-space-pre-line",
            "show-icon": false
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(errors).lookup), 1)];
            }),
            _: 1
          })) : !!user.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("strong", null, _toDisplayString(user.value.userName), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("small", null, [_createVNode(_unref(UseTimeAgo), {
            time: _unref(DateTime).fromISO(user.value.registerDate, {
              zone: 'UTC'
            }).toJSDate()
          }, {
            default: _withCtx(function (_ref3) {
              var timeAgo = _ref3.timeAgo;
              return [_createVNode(_component_n_text, {
                depth: "3"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("Member registered " + _toDisplayString(timeAgo), 1)];
                }),
                _: 2
              }, 1024)];
            }),
            _: 1
          }, 8, ["time"])])])]), _createVNode(_component_n_divider), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "actions", {
            user: user.value
          })])], 64)) : _createCommentVNode("", true)];
        }),
        _: 3
      }, 8, ["show"])], 64);
    };
  }
});